import React from 'react';
import { Link } from '../../../../components/Link';
import { Thumbnail } from '../../../../components/thumbnail/thumbnail';
import { SvgPlayCircle } from '../../../../icons';
import { SingleRecording } from '../../../../queries/ats/recordings/types/recording';
import { isBookmarkedRecording } from '../../../../queries/ats/recordings/utils/bookmarked-recording';
import { EpisodeAsset } from '../../../../queries/ats/titles/types/asset';
import { routes } from '../../../../routes/route-utils';
import { useDetailsImage } from '../../use-details-image';
import { BookmarkedThumbnail } from './bookmarked-thumbnail';

interface RecordedProgramThumbnailProps {
  episode: EpisodeAsset;
  recording: SingleRecording;
}

export function RecordedProgramThumbnail({ episode, recording }: RecordedProgramThumbnailProps) {
  const url = routes.recording(recording);

  const src = useDetailsImage({ asset: episode, shape: 'wide', width: 200 });

  const image = {
    src: src,
    alt: `${episode.titleName} cover`,
  };

  if (isBookmarkedRecording(recording)) {
    return <BookmarkedThumbnail recording={recording} image={image} />;
  }

  return (
    <Link to={url}>
      <Thumbnail
        image={image}
        icon={SvgPlayCircle}
        interactions={{
          backdrop: 'hover',
          icon: 'hover',
        }}
      />
    </Link>
  );
}
